var path = '/home/jenkins/workspace/arcade_Arcade-UI_release/app/views/ui/slide.html';
var html = "<div class=\"carousel-slide\" ng-class=\"{active: active}\" ng-transclude></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;